import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getColWidth'
})
export class GetColWidthPipe implements PipeTransform {

/*   getColWidth(name) {
    // console.count('getColWidth: ' + name );
    const found = this.columns.find(col => col.name === name);
    return found ? found.width + 'px' : 0 + 'px';
  } */

  transform(columns: any[], name): string {
    console.count('Pipe getColWidth: ' + name );
    const found = columns.find(col => col.name === name);
    return found ? found.width + 'px' : 0 + 'px';
  }

}
